export default "__VITE_ASSET__DiWBqfm2__"